module.exports = __webpack_public_path__ + "img/logo.dea6c8b2.png";